module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "[Choice 1] I Choose God’s Love"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d7e182423"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c7_r1#Anch00323",
      "id": "Anch0029"
    }
  }, [_c('b', [_vm._v("[")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Choice 1")]), _c('b', [_vm._v("]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("I Choose God’s Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e183623"
    }
  }, [_c('em', [_vm._v("I choose to believe there is a God who knows me perfectly and yet loves me unconditionally.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e184623"
    }
  }, [_vm._v("I’m kinda feeling the pressure now! I mean, what a title—"), _c('em', [_vm._v("10 Choices: A Proven Plan to Change Your Life Forever")]), _vm._v(". That’s really promising a lot, isn’t it? And if you’re like most readers, I get about ten minutes to start delivering on that promise; so let’s start at the top. Let’s go for the mondo, massive, monumental choice right now. Let’s go for the summa cum laude of choices, the absolute mind-bending, life-altering choice . . . (drum roll, please).")]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_01",
      "role": "doc-chapter",
      "title": "Choose God"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e188123"
    }
  }, [_c('b', [_vm._v("Choose God")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e188623"
    }
  }, [_vm._v("The most important choice you will ever make in your life is to choose God. To choose to connect with the God who made you and me and everything in this twisted universe. Not that He made it twisted; He did not. He made it perfect, and we snarled it up with bad choices. But we can still regain most of what we have lost just by choosing God again, on His terms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191023"
    }
  }, [_vm._v("Now I know for many who are reading this, God is just some vague, foggy notion. You may even feel that you really can’t choose God because He’s not the kind of thing you’d choose, right? Have you bought into the notion that either you believe in God or you don’t, and that nothing can alter your current condition? Maybe you have said, like so many people, “You know, I have never had faith, not genuine faith, not like my sister/ friend/mother/other. Sometimes I get a bit of the vertical in a crisis, something like, ‘"), _c('em', [_vm._v("Oh God")]), _vm._v(", save me from that truck that just swerved into my lane!’ but when He does, the feeling passes, and faith fades into, I don’t know, numbness or something.” Is that you—crisis faith for a moment and then nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e195924"
    }
  }, [_vm._v("Possibly you have thought that the faith-in-God thing is a trait you’re born with (or without), like blue eyes, brown hair, or a dad with a membership at the country club. Have you concluded that believing is a characteristic you may or may not have but one you most definitely cannot obtain simply by choosing? Well, let me promise you that God is not like that. God is most assuredly someone you choose, and choosing Him does make a huge difference. He is less like the options on a new car and more like the person you decide to marry. Faith is for people who want it and are willing to go for it with passion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199824"
    }
  }, [_vm._v("In fact, God only shows up for people who are looking, and He chooses to reveal Himself exclusively to people who "), _c('em', [_vm._v("really")]), _vm._v(" want to know Him. In the Bible, God asserts, "), _c('b', [_vm._v("“You will seek me and find me, when you seek me with "), _c('em', [_vm._v("all your heart.")]), _vm._v(" I will be found by you declares the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("”")]), _vm._v(" (Jeremiah 29:13– 14"), _c('em', [_vm._v("a")]), _vm._v(", emphasis mine). Listen, God advertises! What else could the Psalm mean when it says, "), _c('b', [_vm._v("“The heavens declare the glory of God, and the sky above proclaims his handiwork. Day to day pours out speech, and night to night reveals knowledge. There is no speech, nor are there words, whose voice is not heard. Their voice goes out through all the earth, and their words to the end of the world. In them he has set a tent for the sun”")]), _vm._v(" (Psalm 19:1–4). God’s Word and God’s world are full of advertisements about Him, but as with even the best-marketed products, you still have to choose what God is offering.")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e208624"
    }
  }, [_c('b', [_vm._v("THE MOST IMPORTANT CHOICE YOU WILL EVER MAKE IN YOUR LIFE IS TO CHOOSE GOD.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e211225"
    }
  }, [_vm._v("Yep, no question about it, you can choose God. Don’t let some stale seminarian talk you out of it. We’ve all heard the well-worn declaration that we don’t choose God, but He chooses us. You’ve heard that, right? The fact is, both are true; God chooses us, and we choose God! The other way is like arguing that I didn’t choose my wife; my wife chose me. At the human level, we may kid each other over who chose whom first, but to try to describe a relationship in which only one party gets to choose doesn’t make sense. Do you see? Since we’re talking about the God who created us, there’s not much point in arguing over who chose whom first. I suggest we get over the distracting discussions of who chooses who and go at this from the only angle we actually experience—our own. We choose God. That’s the way it feels, and that’s the way it functions. And until you get out of your armchair or ivory tower and choose God for your life, you will always be missing the main ingredient for human happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e215825"
    }
  }, [_vm._v("I’m not trying to say God’s not in charge, but the fact about God’s choice of you being the "), _c('em', [_vm._v("original")]), _vm._v(" choice can cause apathy in humans. We must not lose our sense of responsibility in the ocean of God’s sovereignty. One of the first decisions God made when He planted our ancestors in the garden of Eden was to give them the capacity to make significant choices. Adam and Eve got to choose names for the animals and which of a wild assortment of fruit to eat. But there was only one fruit they were told not to choose. The rest, as they say, is history. Constant choices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e219225"
    }
  }, [_vm._v("When Joshua stood before the nation of Israel and challenged them to make a decision, he was not snickering up his sleeve that it was actually God who would be making all the choices. He didn’t say, "), _c('em', [_vm._v("You really don’t have any options in this, just sit tight, and we’ll see what God does. If you’re the “faith” type of person, something will work out.")]), _vm._v(" No, Joshua faced the nation and raised his voice with an incredible offer . . . "), _c('em', [_vm._v("What’s it gonna be, boys, the idols your fathers worshipped or the one true God?")]), _vm._v(" "), _c('b', [_vm._v("“Choose this day whom you will serve”")]), _vm._v(" (Joshua 24:15). Faith is a volitional thing. You flat-out choose to believe, and there is incredible factual evidence for faith in God upon which to base your decision. Trust me when I tell you, you can choose God. Want some of that evidence?")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_02",
      "role": "doc-chapter",
      "title": "Factual Evidence for Faith in God"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e224826"
    }
  }, [_c('b', [_vm._v("Factual Evidence for Faith in God")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e225326"
    }
  }, [_vm._v("Hang on to something tightly! We’re going to move quickly through some staggering landscape. I want to give you a bird’s-eye view of three rational reasons to choose faith in God. Yes, you’ll be making a choice. I’ll explain the arguments and then invite you to choose whether you believe them or not.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e227226"
    }
  }, [_c('b', [_c('em', [_vm._v("First, the Cosmological Argument")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e227726"
    }
  }, [_vm._v("A commonly accepted rational argument for the existence of God is the idea that for every effect there has to be a cause. I would never do this, but just imagine if I slapped you. The cause—my slap—would create an effect: a red, stinging handprint on your face (and maybe a further cause—your strong reaction—would produce another effect: me flat on my back).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e230026"
    }
  }, [_vm._v("Do you get the idea of cause and effect? Scientists agree that for each and every observable effect there has to have been a cause. For instance, a science professor was out walking in the forest with one of his students.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e231226"
    }
  }, [_vm._v("Along the way, the student said, “Hey, look, there’s a little glass sphere on the ground.” And so they picked it up and examined it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e232026"
    }
  }, [_vm._v("The professor said, “I wonder where that came from?” They looked around but didn’t see anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e232926"
    }
  }, [_vm._v("The student said, “Yeah, I wonder.” Then, with a little twinkle in his eye, he said to his science professor, “I wonder, if it were ten times bigger, would we know where it came from then?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e234026"
    }
  }, [_vm._v("And the professor said, “Well, it had to come from somewhere; I don’t think it just showed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e234926"
    }
  }, [_vm._v("The student responded, “Yeah, I agree with that. But what if it were, like, a hundred times bigger than it is?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e235726"
    }
  }, [_vm._v("“Well,” said the professor after a moment, “all the more reason to know it had to come from somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e236626"
    }
  }, [_vm._v("The student asked, “So let me ask you this. What if it were, like, a million times bigger?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e237626"
    }
  }, [_vm._v("The professor finally picked up the student’s drift and said with a chuckle, “Well, then it would have gotten here on its own.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e239127"
    }
  }, [_vm._v("How foolish! But is that not exactly what people do? They look at the universe that God created, which is so incredibly immense that the numbers are mind-boggling, and quickly reach the conclusion that nothing is bigger or greater than the universe! Light from the closest star in our galaxy takes more than four years to reach us. Our galaxy, the Milky Way, one of countless other galaxies in the universe, would take 150,000 years to cross if we could travel at the speed of light. People are more impressed by the size of creation than by the thought of what miraculous cause would be able to create such an effect! The human mind cannot even comprehend the universe that God made, yet so many people arrogantly say, “No. That is the one time that there was an effect without a cause. Yes, that one time we got this whole thing from nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e243527"
    }
  }, [_vm._v("The Bible calls that "), _c('b', [_vm._v("“suppress[ing] the truth in unrighteousness”")]), _vm._v(" (Romans 1:18 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NKJV")]), _vm._v("). The fact is, when people accept the universe as the ultimate and deny that it had a cause, they are often doing so because they don’t "), _c('em', [_vm._v("want")]), _vm._v(" it to be true. Admitting that the universe has an intelligent cause has far more implications than admitting that something found in a forest had to have been placed there. Admitting the cause of the universe is perilously close to admitting an ultimate accountability for my choices. Because most people are not ready to answer for the choices they make, they don’t want to believe what is painfully obvious: there must be a God who made all of this. All that we see couldn’t possibly have emerged from nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e248727"
    }
  }, [_vm._v("Choosing to believe in a God who made the universe is far easier and more logical than delaying the inevitable moment of accounting to Him. It takes pride to choose to ignore what is obvious in every sincere reflection. There is a God—or there wouldn’t be anything else! That is the cosmological argument for God’s existence. Its details are extremely compelling and can fill several books, but that’s the gist of it. What do you think?")]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_01",
      "role": "doc-chapter",
      "title": "Second, the Evidential Argument"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e251027"
    }
  }, [_c('b', [_c('i', [_vm._v("Second, the Evidential Argument")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e251527"
    }
  }, [_vm._v("Creation itself has design, not just size and scope, but actual, obvious features of design. There are consistent patterns everywhere. The intricacy and the design of creation and the order in the universe insist that it came from an intelligent source. Hugh Ross, a well-known astrophysicist, has calculated fifty-nine things that are “just right” about our earth’s place in the solar system, things that are needed for life to exist. If one of those circumstances were off, life would be impossible on this planet. For example, here are two of the Earth’s characteristics that Ross details in his article, “Fine-Tuning for Life on Earth”:")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "d7e255128"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("The Earth’s proximity to the sun.")]), _vm._v(" If we were closer even by a few degrees, we would be incinerated. If we were farther away, we would freeze to death. Most of our planets have elliptical orbits with a broad variance of proximity to the sun as the seasons come and go, but we have an almost circular orbit, so there is a constancy to our climate that other planets do not enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "d7e257828"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("The Earth’s speed of orbit.")]), _vm._v(" We’re going around the sun at 68,000 miles per hour. If it were any slower or faster, there’d be no life. Again, the precise alignment of our place in the solar system in a way that allows our existence seems to be far more than coincidental."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c38_r1#Anch05128",
      "id": "Anch052293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e260628"
    }
  }, [_vm._v("Let me ask you, if you went down in your basement and saw a thousand dominos standing up on their ends in perfectly ordered succession, would you say to yourself, "), _c('em', [_vm._v("I wonder what blew up down here?")]), _vm._v(" Of course you wouldn’t, and the logic of that needs to extend beyond dominos in your basement to the way you view the universe and the solar system and the planet you live on—and especially the way you choose to view the God who put it all in place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e263428"
    }
  }, [_vm._v("We have already mentioned the words of Psalm 19, "), _c('b', [_vm._v("“The heavens declare the glory of God.”")]), _vm._v(" Creation itself is shouting, "), _c('em', [_vm._v("There is a God! There is a God!")]), _vm._v(" Some choose to listen while others choose to ignore the demanding sound of God’s created order. In the cosmological argument, we acknowledge God as the source of the universe itself. In the evidential argument, we choose to admit that design is proof of a designer. To do otherwise would put us right in the sights of Psalm 14:1, which says"), _c('b', [_vm._v(", “The fool says in his heart, ‘There is no God.’”")]), _vm._v(" What do you think?")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_02",
      "role": "doc-chapter",
      "title": "Third, the Moral Argument"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e268129"
    }
  }, [_c('b', [_c('i', [_vm._v("Third, the Moral Argument")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e268629"
    }
  }, [_vm._v("More than six billion people in this world have the same moral DNA. God Himself engraved a moral code on the human heart. It’s one of His fingerprints. You don’t have to teach a kid that it’s wrong to lie or steal. We have that moral code within us—I know I sure did!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e270329"
    }
  }, [_vm._v("When I was three or four years old, all the kids in my neighborhood played with marbles. We’d make a hole in the dirt with our heels in the middle of a large circle. Then we would try to roll our marbles from outside the circle so they would land in the hole (maybe that was what set me up to love golf!). If the marble went in the hole, it was safe, but if it stayed outside the hole, it was game to be taken by another player. We could aim for the hole as well as the “sitting duck” marbles. Every time one of your marbles hit another one, you got them both. It was a brutal game that left a lot of kids crying when they literally lost their marbles. All of the big kids walked around with sacks full of marbles. One of my earliest memories is of going over to a friend’s house to play marbles. He had this amazing silver sphere, which was a large ball bearing about the size of a child’s fist. In my young imagination, I pictured all the marbles I could take out with this giant one. So I stole it. My sinful heart wanted it, and before I could stop myself, it was in my pocket and I was out the door. What now? Well, when I left my friend’s house, the little ball weighed a few ounces. But, of course, by the time I walked the two blocks home, that sphere in my sweaty palm weighed a thousand pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e276229"
    }
  }, [_vm._v("I dragged myself into the front door and looked up through drooping eyes to my mother behind her apron, with her hands on her hips. She knew right away something was very wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277429"
    }
  }, [_vm._v("“What’s the matter?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277929"
    }
  }, [_vm._v("I produced the contents of my pocket and became pathetically unglued. “I stole the marble!” I cried as I collapsed into a bundle of tears and regret.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e279029"
    }
  }, [_vm._v("How could that be? How could that little four-year-old boy be so gripped by the wrongness of what he had done? Surely you could tell a similar story. It’s God’s moral law, written on our hearts. Every one of us has it, even if we deny or ignore it, stuff it down or sin against it. Animals don’t have that. Only people created in the image of God have a moral compass that points in the same direction no matter what corner of the globe they were birthed onto. It’s God’s fingerprint upon you. It points directly to your moral center and shouts the reality that you are more than an animal and the product of chance. You were made by God and for God, and your heart will always be restless until you choose that identity as your center.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e745",
      "role": "presentation",
      "src": "images/10_Choices_0030_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e283730"
    }
  }, [_vm._v("I have given these arguments for God’s existence in a superficial way on purpose. Most people don’t require more. According to recent polls in the United States, over 90 percent of the population still believes God exists.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e284830"
    }
  }, [_vm._v("However, if you are one of the few whose intellect calls out for a deeper consideration of these and other proofs, please don’t believe that I have come remotely close to exhausting the subject. Volumes by Lee Strobel ("), _c('em', [_vm._v("The Case for Faith")]), _vm._v(") and Ravi Zacharias ("), _c('em', [_vm._v("Jesus Among Other Gods")]), _vm._v("), as well as numerous other books, discuss these issues in greater detail. My prediction is that the further you honestly dig, the more it will bolster your faith. The bottom line is that there are plenty of good, rational reasons to believe in God, and if you don’t believe, it’s because you choose not to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e289630"
    }
  }, [_vm._v("Hugh Ross’s Reasons to Believe Web site is a trove of helpful information. All in all, Ross and his team have listed dozens of these highly improbable features of our earth’s design. Among the fascinating statistics on that site, I found this statement: “Much less than one chance in a hundred thousand trillion, trillion, trillion, trillion, trillion, trillion exists that even one such planet would occur anywhere in the universe.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c38_r1#d7e38352293",
      "id": "d7e291930",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" We live in a universe that demands an explanation outside what is observable or provable by traditional means.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e293430"
    }
  }, [_vm._v("Some people stand off at a distance with phony intellectualism and say, “Well, I don’t see the proof for God.” Why don’t you go out on a starlit night and look up at the skies. Now what’s your answer? “What’s your proof,” you ask? I’ll tell you—the heavens are declaring the glory of God. The scientific world has no substantive, satisfying explanations for the existence of the universe. They just have speculations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e296231"
    }
  }, [_vm._v("I’m going to go with the fact there is a God. I don’t understand Him or how He made it all. But it doesn’t take a genius to see that you can’t throw a stick of dynamite into a printing factory and get the Declaration of Independence. A design shouts a designer. I’m convinced by these arguments; therefore, I choose. I choose God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e298231"
    }
  }, [_vm._v("But listen, I do not choose just any God.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_03",
      "role": "doc-chapter",
      "title": "You’ve Got to Choose the Right God"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e298931"
    }
  }, [_c('b', [_vm._v("You’ve Got to Choose the Right God")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e299431"
    }
  }, [_vm._v("When someone tells you he believes in God, ask him to clarify which God he believes in. Ephesians 4:6 reminds us there is "), _c('b', [_vm._v("“one God and Father of all, who is over all and through all and in all.”")]), _vm._v(" You see, some people are going around these days inventing their own god according to their damaged moral compass. Others, grudgingly admitting there must be a god, turn to a caricature of God they have picked up along the way. These gods are about as divinely ineffective as no God at all! In that sense, God has something in common with Elvis—many imposters but only one "), _c('em', [_vm._v("real thing.")]), _vm._v(" In fact, there may be a few Elvis impersonators who come close to the original, but all the imitation gods miss the genuine by a mile. Have you seen or heard of any of these?")]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_03",
      "role": "doc-chapter",
      "title": "Fake God #1: The Gruff God"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e304331"
    }
  }, [_c('b', [_c('i', [_vm._v("Fake God #1: The Gruff God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e304931"
    }
  }, [_vm._v("A lot of people think of God as a cranky deity. He’s always in a sort of bad mood and is easily irritated. Remember the little story we read as kids called "), _c('em', [_vm._v("Three Billy Goats Gruff")]), _vm._v("? Some people think God is like the awful one-eyed troll who lives under the bridge and gets all sideways whenever someone wants to get across. Now maybe your dad or some other authority figure in your life is or was a bit like that, but God is not cranky in the least. Let’s separate truth from fiction. God doesn’t get gruff, and He is never in a bad mood. In fact, God loves you deeply! But more on that later.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_04",
      "role": "doc-chapter",
      "title": "Fake God #2: The Game God"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e308332"
    }
  }, [_c('b', [_c('i', [_vm._v("Fake God #2: The Game God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e308832"
    }
  }, [_vm._v("Some people think God sneaks around playing games such as hide-and-seek. "), _c('em', [_vm._v("Where are You now, God? I can’t find You.")]), _vm._v(" To which God answers, "), _c('em', [_vm._v("You’re getting warmer. Oh, now you’re getting colder")]), _vm._v(". Some erroneously think God leads us like a Simon Says game: "), _c('em', [_vm._v("Simon says do this; Simon says do that; do this. Hah! I tricked you!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e311432"
    }
  }, [_vm._v("But God is not like that. He does not change; He is ever the same. And while His actions are sometimes hard to understand, His ways will always ultimately prove to be for your good because He loves you deeply! But that’s for later.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_05",
      "role": "doc-chapter",
      "title": "Fake God #3: The Guessing God"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e313132"
    }
  }, [_c('b', [_c('i', [_vm._v("Fake God #3: The Guessing God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e313632"
    }
  }, [_vm._v("Some people follow a Guessing God, as in "), _c('em', [_vm._v("I think He’s happy with me today. At least I hope He is. He might not be, though. I never know. I’d better not go to church since I didn’t do so good this week.")]), _vm._v(" They imagine God is capricious and unpredictable in the extreme as though He intentionally keeps us off balance by continuously changing the rules so we really never can know how it all works. But God is not like that. He’s laid out perfectly all the regulations for human happiness in His Word, the Bible. He wants us to know what choices to make so we can live with confidence. God is extremely predictable. He cannot lie because that would be sin, and He will not lie because He loves you deeply! More on that later.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_06",
      "role": "doc-chapter",
      "title": "Fake God #4: The Genie God"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e318132"
    }
  }, [_c('b', [_c('i', [_vm._v("Fake God #4: The Genie God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e318732"
    }
  }, [_vm._v("North Americans know all about this fake God. People pull out their lamps and rub them. "), _c('em', [_vm._v("Oh, give me favor today, Genie God. Grant me three wishes.")]), _vm._v(" This fake god is the one we bring out when we feel an urgent need. Once the difficulty is past, we put Him back in the lamp for later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e320632"
    }
  }, [_c('em', [_vm._v("OK, now go away, God. I’ll call you when I need you.")]), _vm._v(" Sadly, there are preachers on every corner selling this god we have made to suit our own whims. Sorry if you didn’t know, but the North American Genie God is not the real God.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_07",
      "role": "doc-chapter",
      "title": "God"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e322833"
    }
  }, [_c('b', [_c('i', [_vm._v("God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e323333"
    }
  }, [_vm._v("But there is a real God who created the universe, who placed Adam and Eve in the garden, and who came in love to correct the consequences of their sinful choices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e324433"
    }
  }, [_vm._v("The Bible says that God "), _c('em', [_vm._v("is")]), _vm._v(" love—not only that God does loving things but also that His very nature is love. We may do loving things, but we’re not love. When 1 John 4:8 says "), _c('b', [_vm._v("“God is love,”")]), _vm._v(" it’s making an incredible statement about how very loving and selfless God really is.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_04",
      "role": "doc-chapter",
      "title": "I Choose God’s Love"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e327133"
    }
  }, [_c('b', [_vm._v("I Choose God’s Love")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e327633"
    }
  }, [_vm._v("I’ve been working with people long enough to know that when I say God is love, some people pull back and look at me sideways. Often, they can hardly hide the anger in their tone as they say, “Really? God is "), _c('em', [_vm._v("love")]), _vm._v("? Well, if that’s true, then how could He have allowed . . .”—and out comes a painful story. Are you like that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e330233"
    }
  }, [_vm._v("Something happened to you. A wrong was done to you. A selfish person took what wasn’t his. Maybe one of your children broke your heart, or you don’t have children, or you can’t do anything about the starving children in Africa. My point is that many people point to God when pain comes because they cannot reconcile what they see with the message that "), _c('em', [_vm._v("God loves them")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e332433"
    }
  }, [_vm._v("I’m so sorry for your hurt—I truly am.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e332933"
    }
  }, [_vm._v("Please hear me now. The way out of that corner of confusion is not to deny or run from God’s heart for you. Instead, you must turn and look squarely into the reality of who He actually is. Too often we self-define God’s love: “This is my concept of love, and God must conform to this view, or I can’t believe He is loving.” Many have made this mistake without realizing or calculating the fallout from such a belief-banishing choice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e335233"
    }
  }, [_vm._v("God has never represented His love for you or me as that pampering “here, Billy, have another cupcake; take the one with the extra icing,” permissive-mother kind of love. But I do understand why people sometimes struggle to see God as loving.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e336833"
    }
  }, [_vm._v("For example, most people would agree that when you love someone, you protect that person, right? God’s love "), _c('em', [_vm._v("is")]), _vm._v(" a "), _c('em', [_vm._v("protecting")]), _vm._v(" love, but it’s not always a "), _c('em', [_vm._v("preventing")]), _vm._v(" love. God doesn’t always keep hard things from happening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e339734"
    }
  }, [_vm._v("Here’s why. He has higher purposes for our pain:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e340434"
    }
  }, [_vm._v("• "), _c('em', [_vm._v("God may allow pain to humble us.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d9t00134"
    }
  }, [_vm._v("When we are brought low by pain, we see how much we need Him. One of C. S. Lewis’s best-known comments describes pleasure as God’s whispers and pain as God’s megaphone!")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e342534"
    }
  }, [_vm._v("• "), _c('em', [_vm._v("God sometimes allows pain to restore us.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d7e343234"
    }
  }, [_vm._v("Some of you were so far from God, off on your own, running away from God, going who knows where with your future. God allowed some hard thing in your life so that the pain of it brought you back to Him. If you would have never turned to Him without that heartache, isn’t it true that in some sense that pain was a very loving thing for God to allow? Wasn’t it that hurt that brought you to the wonderful place of asking for His help?")]), _vm._v(" "), _c('p', {
    staticClass: "ul1",
    attrs: {
      "id": "d7e345934"
    }
  }, [_vm._v("A hundred years from today, as awful as that pain was, you’ll thank God for it if you choose to let its purpose be fulfilled in you. God’s love is revealed in the ultimate purpose for which He allows our momentary affliction. God does not have to prove He loves us at the end of every hour or every day. He does invite us to trust what He is doing and choose to embrace by faith that time will reveal the reality of His love. Friend, choose to believe He loves you!")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e348534"
    }
  }, [_vm._v("• "), _c('em', [_vm._v("Sometimes God allows pain to refine us.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d7e349334"
    }
  }, [_vm._v("This refining fire allows us to be more like Him. I’ve said to my wife, Kathy, many times, “I hate to think of the person that I would be, apart from God in my life.” I shudder to imagine where I would be without God’s refining influence. Without God allowing difficult things into my life, what kind of husband and father would I be today? What kind of pastor or friend would I be? What kind of man would I be without the excruciating hurts that have driven me to my knees before the God who loves to refine me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e352735"
    }
  }, [_vm._v("Looking back, it’s His love and mercy I see, even when His protection does not always prevent pain in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e898",
      "role": "presentation",
      "src": "images/10_Choices_0035_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e353935"
    }
  }, [_vm._v("Yes, God loves you with a perfecting love. You are under construction, my friend. God is working on you. There will be difficult times, but you can trust Him. No pain is allowed into your life but that which He chooses to use for your good. Your loving, protecting Father measures out the trial and carefully watches over you every moment. His eyes are upon you (Job 34:21). You are never far from His thoughts (Psalm 139:17). He counts the hairs on your head (Matthew 10:30). He saves your tears in a bottle (Psalm 56:8). He loves you with an everlasting love (Jeremiah 31:3). But let His love be what it really is—a perfecting love.")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e359335"
    }
  }, [_c('b', [_vm._v("GOD IS WORKING ON YOU. THERE WILL BE DIFFICULT TIMES, BUT YOU CAN TRUST HIM.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e361735"
    }
  }, [_vm._v("I choose God’s love. What do you choose?")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_05",
      "role": "doc-chapter",
      "title": "Don’t Miss Heaven by Eighteen Inches"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e362435"
    }
  }, [_c('b', [_vm._v("Don’t Miss Heaven by Eighteen Inches")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e362935"
    }
  }, [_c('b', [_vm._v("“For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life")]), _vm._v(". ” John 3:16 has been considered by people of faith through the centuries as the most important verse in all of God’s Word. One of the greatest authors of our day, Max Lucado, called John 3:16 the Hope Diamond of the Bible. It’s the centerpiece. Everything starts and flows from John 3:16. Nothing in life will truly make sense until John 3:16 makes total sense to you. By "), _c('em', [_vm._v("total")]), _vm._v(" I mean in your head-sense and in your heart-sense. The message of that single verse has to permeate your thoughts and your feelings. Just eighteen inches separate those two locations in you, but responding to God with both is eternal and essential.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368736"
    }
  }, [_vm._v("Did Rollen Stewart understand John 3:16? You probably don’t know the name, but you would certainly recognize his screen character. He was the guy in the rainbow wig seen in the background at sporting events during the late 1970s and 1980s ducking in and out of the crowds with a sign that read J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN ")]), _vm._v("3:16. For a while he was almost a fixture on the screen during field goal attempts in football, visible between the goalposts. By the 1990s the only place he showed up was in the news. "), _c('em', [_vm._v("Whatever happened to him?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e373536"
    }
  }, [_vm._v("Now he’s in prison for three consecutive life terms. He took a woman hostage. He fired off guns at airplanes. He attempted to set off some bombs in a church. You’re thinking, "), _c('em', [_vm._v("What? But I thought he was, like, the John 3:16 guy? You know, “God so loved the world”?")]), _vm._v(" Yeah, I thought so too. I don’t know his story in detail, but maybe back when he was bobbing in and out of television coverage, trying to get others to embrace John 3:16, he was not fully there himself. I don’t want to be hard on him; I hope he now embraces the reality of the message more than he did back then. Sadly, he stands as an illustration not of the power and life-change that verse can bring, but of the real danger of choosing to only partially embrace it. Yes, you can choose to read and understand something without choosing to make it fully your own. You can carry a sign and not live by what it says!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e378036"
    }
  }, [_vm._v("You’ve got to choose to believe with your whole heart not just that God loves, but that He truly loves "), _c('em', [_vm._v("you")]), _vm._v(", as you are, with full knowledge of your shortcomings. You’ve got to put your whole weight down on God’s love as your identity. Beyond an intellectual piece of information, you must choose to embrace God’s love for you as a life-altering identity to rest upon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e380236"
    }
  }, [_vm._v("The key word that unlocks the door to John 3:16 is "), _c('em', [_vm._v("believe")]), _vm._v(". And "), _c('em', [_vm._v("believe")]), _vm._v(" always includes "), _c('em', [_vm._v("choice")]), _vm._v(".")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_06",
      "role": "doc-chapter",
      "title": "A Father’s Love"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e382336"
    }
  }, [_c('b', [_vm._v("A Father’s Love")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e382836"
    }
  }, [_vm._v("I want to tell you a story.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e383536"
    }
  }, [_vm._v("Imagine for a moment you have a son. Your son was a great kid. You loved him with a love you didn’t know was in you. He was such a blessing to your family and brought you incredible joy, but something happened to him in high school. He changed and became awful, arrogant, and insolent. To your surprise and deep disappointment—in a matter of months, it seems—your son became someone you couldn’t talk to or tell anything. There were many sleepless nights of tossing and turning, weeping, and wondering, "), _c('em', [_vm._v("Where did my sweet son go")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e387337"
    }
  }, [_vm._v("One day he showed up and demanded, “Mom and Dad, I want my inheritance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e388137"
    }
  }, [_vm._v("You replied, “Well, generally the first thing that happens before you can have an inheritance is the people who have the money have to die. And, as you can see, we are very much alive here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e389337"
    }
  }, [_vm._v("To which he answered, “I don’t really care what you say. I know I’m in the will. I just want my money, and I want it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e390137"
    }
  }, [_vm._v("When a son says about his inheritance, “I just want my money, and I want it now,” what he’s really saying is, “I wish you were dead.” Imagine how that would break your heart and trash everything you had previously treasured.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e391337"
    }
  }, [_vm._v("Your son’s attitude and request created a tough choice for you. How does unconditional love respond in the face of rejection? For some reason you felt it best for your son to exhaust his ego and energy—to self-destruct if necessary. So you said, “Fine, son. If you really think that will make you happy, and you’ve decided having this now is better than us, just take your inheritance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393337"
    }
  }, [_vm._v("And he did. He packed his stuff and left. You didn’t hear from him for a long time. But you did hear through the grapevine that he’d gotten himself into an awful, shameful lifestyle. It grieved you deeply to think of the filthy things he was choosing—the drinking and carousing, the women, the addictions, the mess.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e395137"
    }
  }, [_vm._v("In the meantime, your son thought everything was going just fine. He had all the money and the friends he wanted. He was living it up, spending his inheritance, partying with his piggish pals, and living like the selfish animal he had chosen to be until . . . his money ran out. His credit cards were rejected. The symbols of the good life—the big screen TV, the sports car, the entertainment center—were all repossessed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e397337"
    }
  }, [_vm._v("It was an amazing coincidence, but around the same time he reached into his pocket to pay and came up empty, he also noticed that he suddenly had no more friends. Apparently his friends were figments of his imagination. And he found himself "), _c('em', [_vm._v("very")]), _vm._v(" much alone!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e400038"
    }
  }, [_vm._v("A short while later he had this most radical of ideas: "), _c('em', [_vm._v("I’m going to have to get a job")]), _vm._v(". News flash! But in the real world, if you don’t finish high school, it’s kind of tough to get a job. Finally, he found a job on a farm—feeding pigs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e401538"
    }
  }, [_vm._v("Well, he soon figured out that if you get a job that only takes seven minutes to learn, you don’t get paid very much for it either. So even though he was working, he hardly had enough money to put a roof over his head. He had nothing, and no one was to blame but himself. His arrogance and pride began to fade under the bright lights of personal poverty and slave labor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e403738"
    }
  }, [_vm._v("In fact, he got so hungry that as he was throwing out the pig slop, he started to imagine what it tasted like. In that moment he thought to himself, "), _c('em', [_vm._v("Man, my dad treated the farm hands better than this")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e405338"
    }
  }, [_vm._v("In the pain of the pigsty, his heart began to change. He felt ashamed for how he had treated his parents and how he had been living. Home was not looking so bad anymore. In his head, he began dreaming of a speech he would give his dad. "), _c('em', [_vm._v("I’ll tell it like it is. I’m not the person I used to be. I’m going to say, “Dad, I don’t deserve to be your son . . . but I’ll be one of your slaves.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e407638"
    }
  }, [_vm._v("So he started for home. On the road he kept wondering, "), _c('em', [_vm._v("What’s Dad going to say when he sees me")]), _vm._v("? All the while he remembered how he left his parents. Now what would they say? “"), _c('em', [_vm._v("Oh, you do look a little like our son, but he died to us a long time ago.” Will Dad be like that")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e409938"
    }
  }, [_vm._v("I think you realize by now that this is a story Jesus told when He wanted to describe His Father’s love. The son was blocks from home—Luke 15:20 says, "), _c('b', [_vm._v("“But while he was still a long way off")]), _vm._v(" ”—but close enough that his father recognized him. I think that father went down that road every day looking for his son. Every day. Amazingly, he couldn’t wait for the son to come back. He waited and watched—always on pins and needles in hopes that maybe today would be the day his son returned. And so "), _c('b', [_vm._v("“his father saw him and felt compassion.”")]), _vm._v(" The father wasn’t angry; he wasn’t going to unload on his boy. He didn’t hold a hateful grudge. The father felt a gut wrench when he saw his son. As a human dad, maybe he thought, "), _c('em', [_vm._v("I was young and stupid once too.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e415439"
    }
  }, [_vm._v("When the father felt compassion, he instantly connected with his son’s feelings. "), _c('em', [_vm._v("He must feel so low; he must be so devastated. He must be so disappointed with the choices that he’s made.")]), _vm._v(" "), _c('b', [_vm._v("“But while he was still a long way off, his father saw him and felt compassion,”")]), _vm._v(". . . (this is my favorite part) "), _c('b', [_vm._v("“and ran”")]), _vm._v(" (Luke 15:20).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e418239"
    }
  }, [_vm._v("You don’t see God running a lot in the Bible. He mostly is just there. But Jesus pictured God the Father running. He ran to His son. What message does that send? Can you picture it? The son looks like he just came out of a pigsty. The father runs to him, embraces him, and begins kissing him on the neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e420039"
    }
  }, [_vm._v("But the son needs to get his speech out. "), _c('b', [_vm._v("“Father, I have sinned against heaven and before you. I am no longer worthy to be called your son”")]), _vm._v(" (Luke 15:21).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e421839"
    }
  }, [_vm._v("That’s as far as he got. "), _c('b', [_vm._v("“But the father said to his servants ‘Bring quickly the best robe, and put it on him, and put a ring on his hand, and shoes on his feet. And bring the fattened calf and kill it, and let us eat and celebrate. For this my son was dead, and is alive again; he was lost, and is found’ ”")]), _vm._v(" (Luke 15:22–24). The father in the story is so fired up. Can you picture the tears of joy streaming down his face and the smile that doesn’t go away? Can you put yourself in the place of that father?")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e426639"
    }
  }, [_c('b', [_vm._v("NO MATTER WHERE YOU HAVE BEEN OR WHAT YOU’VE DONE, OR THE POOR CHOICES YOU HAVE MADE—GOD LOVES YOU LIKE THIS.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e429939"
    }
  }, [_vm._v("This is how God feels about you. Jesus’ story about His Father’s love is also a story about you. No matter where you have been or what you’ve done, or the poor choices you have made—God loves you like this. Life will never make sense until you get your arms around this reality. He loves you with an everlasting love. Words cannot describe the love that God has for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e433540"
    }
  }, [_vm._v("But you have to choose it. You have to believe it. You’ve got to get up out of the pigsty and come home. He is waiting for you. He is watching for you. He is longing for you. You will only be able to imagine it when you are in His embrace. No one can make this choice for you. You have to choose it yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e435540"
    }
  }, [_c('em', [_vm._v("I choose to believe God loves me. What’s your choice?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e436040"
    }
  }, [_vm._v("What will you do with a love like this? You didn’t earn it. You don’t deserve it. You can’t maintain it. Best of all, you don’t need to. This love comes from God Himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e437240"
    }
  }, [_vm._v("Drink it deeply; breathe it in until your lungs are full. Dive into the bottomless sea of God’s love, stay under until you can’t hold it in anymore, then burst from the surface and shout to the world, “There is a God who loves me—and I choose to believe it!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e438740"
    }
  }, [_vm._v("It doesn’t matter what people say or think. Choose to believe that God loves you! That choice will change your life.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_07",
      "role": "doc-chapter",
      "title": "A Choice to Make"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e440041"
    }
  }, [_c('b', [_vm._v("A Choice to Make")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_08",
      "role": "doc-chapter",
      "title": "Acknowledge the Choice"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e440541"
    }
  }, [_c('b', [_c('i', [_vm._v("Acknowledge the Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e441041"
    }
  }, [_vm._v("• Where do you find yourself at this moment? Choose one:")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d7e441541"
    }
  }, [_vm._v("___ Clueless about God")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d9t00241"
    }
  }, [_vm._v("___ Wondering about God")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d9t00341"
    }
  }, [_vm._v(" ___ Wanting to know God")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e442641"
    }
  }, [_vm._v("• Can you think of any reason you wouldn’t choose God’s love?")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_09",
      "role": "doc-chapter",
      "title": "Consider the Choice"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e443341"
    }
  }, [_c('b', [_c('i', [_vm._v("Consider the Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e443941"
    }
  }, [_vm._v("• How is putting off this choice a choice for you?")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e444441"
    }
  }, [_vm._v("• What immediate effect do you think this choice would have in your life if you made it?")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_10",
      "role": "doc-chapter",
      "title": "Make the Choice"
    }
  }, [_c('h3', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e445441"
    }
  }, [_c('b', [_c('i', [_vm._v("Make the Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e445941"
    }
  }, [_vm._v("• The choice to respond to God and accept His love can’t be made for you. You have to make it on your own. You can make that choice in a simple prayer: “Creator God, I accept Your love for me.” Say it out loud and let it settle into your soul.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_08",
      "role": "doc-chapter",
      "title": "A Choice Prayer"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e447541"
    }
  }, [_c('b', [_vm._v("A Choice Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e448041"
    }
  }, [_c('em', [_vm._v("Father, thank You for Your love. Thank You that You love me with an everlasting love. Thank You that the God of the universe, who doesn’t need me, who is not diminished by my absence or increased by my presence, who is complete in Himself—somehow beyond what I can think or imagine—has chosen to set His love upon me. I respond to Your choice with a choice of my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e450141"
    }
  }, [_c('em', [_vm._v("God, I pray for any person thinking now about the manner of his life in regard to this. Perhaps he has never made the choice to accept Your love for him. Might he say from his heart in this moment, “I’m going to step toward that. I choose to believe there is a God who loves me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e451541"
    }
  }, [_c('em', [_vm._v("Because of Your great love. Amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e452642"
    }
  }, [_c('b', [_vm._v("Who is a God like you, pardoning iniquity and passing over transgression for the remnant of his inheritance? He does not retain his anger forever, because he delights in steadfast love.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx15",
    attrs: {
      "id": "d7e453942"
    }
  }, [_vm._v("—M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICAH 7:18 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e454442"
    }
  }, [_c('b', [_vm._v("As far as the east is from the west, so far does he remove our transgressions from us.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx15",
    attrs: {
      "id": "d7e455442"
    }
  }, [_vm._v("—P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SALM 103:12 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e455942"
    }
  }, [_c('b', [_vm._v("And getting into a boat he crossed over and came to his own city. And behold, some people brought to him a paralytic, lying on a bed. And when Jesus saw their faith, he said to the paralytic, “Take heart, my son; your sins are forgiven.” And behold, some of the scribes said to themselves, “This man is blaspheming.” But Jesus, knowing their thoughts, said, “Why do you think evil in your hearts? For which is easier, to say, ‘Your sins are forgiven,’ or to say, ‘Rise and walk’? But that you may know that the Son of Man has the authority on earth to forgive sins”—he then said to the paralytic—“Rise, pick up your bed and go home.” And he rose and went home. When the crowds saw it, they were afraid, and they glorified God, who had given such authority to men.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx15",
    attrs: {
      "id": "d7e460542"
    }
  }, [_vm._v("—M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATTHEW 9:1–8 ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3bcfdbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MacD_ISBN9781418573447_epub_c13_r1.vue
// module id = 87
// module chunks = 0